// Guia de solução do Log de erros do realizado: para cada tipo, o que aconteceu em linguagem
// simples, o passo a passo para corrigir, onde ir na plataforma e se o erro some sozinho
// (automatico) ou precisa ser marcado como resolvido à mão depois de conferido.

const R = "/gestao-realizado";
const IR = {
  depara: { rotulo: "Abrir De-para de projetos", path: `${R}/de-para` },
  importacao: { rotulo: "Abrir Importação (CSV)", path: `${R}/importacao` },
  notas: { rotulo: "Abrir Notas fiscais", path: `${R}/notas-fiscais` },
  solicitacoes: { rotulo: "Abrir Solicitações de NF", path: `${R}/solicitacoes` },
  saldo: { rotulo: "Abrir Saldo de competência", path: `${R}/saldo-competencias` },
  categorias: { rotulo: "Abrir Categorias do Omie", path: `${R}/despesas/categorias` },
  departamentos: { rotulo: "Abrir De-para de departamentos", path: `${R}/despesas/departamentos` },
};

// Linhas de CSV: o mesmo texto serve para todos os erros de carga.
const REIMPORTAR = "Corrija a linha na planilha do Google, baixe a aba de novo em CSV e reimporte em Importação (CSV) — a carga refaz o log dessa aba.";

export const GUIA = {
  PROJETO_NAO_MAPEADO: {
    oQue: "O nome do projeto escrito na planilha/formulário não corresponde a nenhum projeto do cadastro. Enquanto isso, o valor não aparece no Faturamento por projeto.",
    passos: [
      "Abra De-para de projetos e procure o nome que aparece na coluna Referência.",
      "Escolha o projeto do cadastro equivalente e salve.",
      "Se o projeto ainda não existe no cadastro, cadastre-o primeiro e depois faça o de-para.",
    ],
    acao: IR.depara,
    automatico: "Sai do log sozinho assim que o de-para é salvo (todas as linhas com esse nome são reclassificadas).",
  },
  TIPO_RECEITA_VAZIO: {
    oQue: "A solicitação veio sem indicar Backlog ou Nova Venda.",
    passos: ["Nada a corrigir: desde 27/10/2026 todo faturamento do formulário é tratado como Backlog.", "Marque como resolvido."],
  },
  SALDO_DIVERGENTE: {
    oQue: "O saldo que a plataforma calculou para a competência (valor da competência − solicitações vinculadas) é diferente do Saldo Bruto da aba Controle comp.",
    passos: [
      "Abra Saldo de competência e localize o projeto e o mês da mensagem.",
      "Compare as solicitações vinculadas com as da planilha: normalmente falta uma solicitação, há uma a mais ou ela foi para o mês errado.",
      "Se a planilha estiver errada (fórmula, linha duplicada), corrija e reimporte o Controle comp.",
      "Se a plataforma estiver certa e a planilha não for mais usada como referência, marque como resolvido.",
    ],
    acao: IR.saldo,
    automatico: "É recalculado a cada conciliação; some quando os dois saldos baterem.",
  },
  NF_NAO_IDENTIFICADA: {
    oQue: "A linha cita uma nota fiscal, mas o número não pôde ser lido com segurança (texto livre, mais de um número ou baixa sem nº de NF). A nota não foi vinculada.",
    passos: [
      "Clique na seta da linha e leia o texto original para descobrir qual é a NF.",
      "Em Notas fiscais, encontre a nota e use Vincular na coluna Solicitação para ligá-la à solicitação certa.",
      "Se a observação só fala de cancelamento/substituição e não há nota a vincular, marque como resolvido.",
    ],
    acao: IR.notas,
  },
  CLIENTE_SEM_CNPJ: {
    oQue: "Cliente nacional sem CNPJ válido. Sem CNPJ, a nota emitida no OMIE não consegue ser casada automaticamente com a solicitação.",
    passos: [
      "Confira o CNPJ do cliente (14 dígitos) na planilha.",
      "Se for cliente do exterior, preencha o tipo de cliente como Internacional.",
      REIMPORTAR,
    ],
    acao: IR.importacao,
  },
  COMPETENCIA_INVALIDA: {
    oQue: "Não foi possível ler o mês de competência (formato esperado MM/AAAA) — a linha foi ignorada e não entrou na plataforma.",
    passos: [
      "Abra a seta da linha para ver o valor que veio na planilha.",
      "Ajuste a competência para MM/AAAA (ex.: 09/2026).",
      REIMPORTAR,
      "Se veio do formulário, confira com quem solicitou e corrija na planilha de controle.",
    ],
    acao: IR.importacao,
  },
  VALOR_ZERO: {
    oQue: "Linha importada com valor R$ 0,00. Ela entrou, mas não soma nada no faturamento.",
    passos: [
      "Se a solicitação foi cancelada ou é só um registro, está correto: marque como resolvido.",
      "Se faltou digitar o valor, " + REIMPORTAR.charAt(0).toLowerCase() + REIMPORTAR.slice(1),
    ],
    acao: IR.importacao,
  },
  VALOR_INVALIDO: {
    oQue: "O valor não é um número reconhecível (ex.: texto, célula com erro de fórmula) — a linha foi ignorada.",
    passos: ["Ajuste o valor para número (ex.: 1.234,56).", REIMPORTAR],
    acao: IR.importacao,
  },
  DATA_INVALIDA: {
    oQue: "O Carimbo de data/hora não é uma data válida — a linha foi ignorada.",
    passos: ["Corrija o carimbo para o formato dd/mm/aaaa hh:mm:ss.", REIMPORTAR],
    acao: IR.importacao,
  },
  EMPRESA_INVALIDA: {
    oQue: "O Prestador de serviços está vazio ou não é CIGTA, GT4W, CRIA ou FLOW. A linha entrou sem empresa: não aparece nos filtros por empresa e não casa com as notas do OMIE.",
    passos: [
      "Preencha o Prestador com CIGTA, GT4W, CRIA ou FLOW na planilha.",
      REIMPORTAR,
      "Se veio do formulário, confira com quem solicitou qual empresa emite a nota.",
    ],
    acao: IR.importacao,
  },
  NF_DUPLICADA: {
    oQue: "O mesmo número de nota aparece em mais de uma linha da mesma empresa.",
    passos: ["Confira em Notas fiscais qual solicitação é a certa para a nota.", "Corrija a linha repetida na planilha e reimporte, ou ajuste o vínculo à mão."],
    acao: IR.notas,
  },
  SYNC_PLANILHA: {
    oQue: "A solicitação foi salva na plataforma, mas o envio para a planilha do Google falhou (planilha fora do ar, sem permissão ou aba renomeada).",
    passos: ["Abra Solicitações de NF e clique em Reenviar pendentes à planilha.", "Se continuar falhando, confira se a planilha e a aba ainda existem com o mesmo nome."],
    acao: IR.solicitacoes,
    automatico: "Sai do log sozinho quando a planilha aceitar o reenvio.",
  },
  SOLICITACAO_SEM_SALDO: {
    oQue: "A solicitação foi marcada como competência, mas não há competência (ou saldo suficiente) para esse projeto e mês no Controle comp.",
    passos: [
      "Abra Saldo de competência e veja se o projeto tem a competência do mês citado.",
      "Se a competência não foi lançada, inclua no Controle comp e reimporte.",
      "Se a solicitação está com mês ou projeto errado, corrija na planilha e reimporte.",
    ],
    acao: IR.saldo,
    automatico: "É refeito a cada conciliação; some quando houver saldo para a solicitação.",
  },
  SOLICITACAO_NAO_ENCONTRADA: {
    oQue: "O envio existe só na aba Emissão de Nota (Competência), não na aba Respostas. A plataforma criou a solicitação a partir da aba Emissão.",
    passos: ["Confira em Solicitações de NF se projeto, valor e competência estão certos.", "Se estiverem, marque como resolvido."],
    acao: IR.solicitacoes,
  },
  NF_SEM_SOLICITACAO: {
    oQue: "Nota emitida no OMIE sem nenhuma solicitação com o mesmo CNPJ e valor para casar automaticamente.",
    passos: ["Em Notas fiscais, encontre a nota e clique em Vincular na coluna Solicitação.", "Escolha a solicitação correspondente."],
    acao: IR.notas,
    automatico: "Sai do log sozinho ao vincular.",
  },
  NF_CASAMENTO_AMBIGUO: {
    oQue: "Mais de uma solicitação poderia ser a dessa nota (mesmo CNPJ e valor). A plataforma escolheu uma, mas vale conferir.",
    passos: ["Em Notas fiscais, confira se a solicitação vinculada é a certa.", "Se não for, ajuste o vínculo."],
    acao: IR.notas,
    automatico: "Sai do log sozinho ao ajustar o vínculo; se já estiver certo, marque como resolvido.",
  },
  NF_NAO_ENCONTRADA_OMIE: {
    oQue: "A nota está na planilha, mas não existe no Contas a Receber do OMIE. Em geral é o número digitado errado na planilha.",
    passos: ["Procure a nota no OMIE pelo cliente e valor para descobrir o número certo.", "Corrija o número na planilha."],
    acao: IR.notas,
    automatico: "Sai do log na próxima sincronização com o OMIE.",
  },
  NF_EXCLUIDA_OMIE: {
    oQue: "A nota já tinha vindo do OMIE e foi excluída de lá.",
    passos: ["Se a nota não vale mais, em Notas fiscais use Desvincular na coluna Solicitação.", "Se foi excluída por engano, recrie no OMIE e sincronize."],
    acao: IR.notas,
  },
  NF_ALTERADA_OMIE: {
    oQue: "Histórico: a nota foi alterada no OMIE e os dados da plataforma já foram atualizados.",
    passos: ["Confira a nota em Notas fiscais.", "Marque como resolvido."],
    acao: IR.notas,
  },
  NF_CANCELADA_LIBERADA: {
    oQue: "Histórico: a nota foi cancelada no OMIE e a solicitação voltou para aguardando nota.",
    passos: ["A nota reemitida é vinculada na próxima sincronização; se não for, vincule à mão em Notas fiscais.", "Marque como resolvido."],
    acao: IR.notas,
  },
  NF_VALOR_DIVERGENTE: {
    oQue: "A nota vinculada tem valor diferente do que a solicitação pediu.",
    passos: [
      "Em Notas fiscais, confira se a nota está ligada à solicitação certa.",
      "Se o vínculo estiver errado, ajuste.",
      "Se a diferença é esperada (retenção, reajuste, arredondamento), marque como resolvido.",
    ],
    acao: IR.notas,
  },
  NFE_OFICIAL_DESALINHADA: {
    oQue: "As abas Nfe oficial e Respostas precisam estar alinhadas linha a linha, e esta linha não bate. A NF foi importada sem vínculo com a solicitação.",
    passos: [
      "Verifique se alguma linha foi inserida ou apagada em só uma das abas e realinhe a planilha, depois reimporte; ou",
      "Vincule a nota à mão em Notas fiscais.",
    ],
    acao: IR.notas,
  },
  REGISTRO_TESTE: {
    oQue: "Linha de teste (contém TESTE) — descartada de propósito.",
    passos: ["Nada a corrigir. Marque como resolvido."],
  },
  CATEGORIA_SEM_CODIGO: {
    oQue: "O lançamento usa uma categoria do plano antigo no Omie, cuja descrição não começa com o código do item (ex.: “2.3.02 …”). Sem o código, a despesa não entra em nenhum item do plano.",
    passos: [
      "Clique em Ver lançamentos para ver quais títulos estão nessa categoria.",
      "No Omie, reclassifique esses lançamentos para a categoria correta do plano novo (ou ajuste a descrição da categoria para começar com o código).",
      "Volte e sincronize o mês de novo.",
    ],
    acao: IR.categorias,
    automatico: "Sai do log na próxima sincronização das despesas.",
  },
  CATEGORIA_NAO_ENCONTRADA: {
    oQue: "O lançamento usa uma categoria que não veio no cadastro de categorias do Omie.",
    passos: ["Em Categorias do Omie, clique em Atualizar.", "Sincronize as despesas de novo."],
    acao: IR.categorias,
    automatico: "Sai do log na próxima sincronização das despesas.",
  },
  LANCAMENTO_SEM_DEPARTAMENTO: {
    oQue: "O título foi lançado no Omie sem departamento. A despesa entra no total, mas não é atribuída a nenhum departamento.",
    passos: [
      "Clique em Ver lançamentos para ver os títulos sem departamento dessa empresa.",
      "No Omie, abra cada título e informe o departamento (ou o rateio entre departamentos).",
      "Volte e sincronize o mês de novo.",
    ],
    automatico: "Sai do log na próxima sincronização das despesas.",
  },
  DEPARTAMENTO_SEM_DEPARA: {
    oQue: "Existe um departamento no Omie que ainda não foi ligado a um departamento da plataforma.",
    passos: ["Abra De-para de departamentos, encontre o departamento citado e escolha o equivalente na plataforma (ou marque para ignorar)."],
    acao: IR.departamentos,
    automatico: "Sai do log sozinho ao salvar e os lançamentos são reclassificados.",
  },
};

// Atalho para a tela de Lançamentos já filtrada, quando o erro carrega empresa/período.
function lancamentosFiltrados(erro, extra) {
  const d = erro.dado || {};
  const p = new URLSearchParams({ mes: "todos", ...extra });
  if (d.empresa) p.set("empresa", d.empresa);
  if (d.emissaoDe) p.set("ano", d.emissaoDe.slice(0, 4));
  return { rotulo: "Ver lançamentos", path: `${R}/despesas/lancamentos?${p}` };
}

// Botões de ação de um erro concreto (o genérico do tipo + atalhos com filtro).
export function acoesDoErro(erro) {
  const guia = GUIA[erro.tipo];
  const acoes = [];
  if (erro.tipo === "LANCAMENTO_SEM_DEPARTAMENTO") acoes.push(lancamentosFiltrados(erro, { departamento: "__sem__" }));
  if (erro.tipo === "CATEGORIA_SEM_CODIGO") acoes.push(lancamentosFiltrados(erro, { item: "__sem__" }));
  if (guia?.acao) acoes.push(guia.acao);
  return acoes;
}

// Para erros de carga de CSV, "linha N" é a linha da planilha de origem — deixa isso explícito.
const ABA_DA_ORIGEM = {
  CARGA_RESPOSTAS: "aba Respostas", CARGA_EMISSAO_COMP: "aba Emissão de Nota (Competência)",
  CARGA_CONTROLE_COMP: "aba Controle comp.", CARGA_NFE_OFICIAL: "aba Nfe oficial",
};
export function ondeEsta(erro) {
  const aba = ABA_DA_ORIGEM[erro.origem];
  if (aba && /^linha \d+/.test(erro.referencia || "")) return `Na planilha: ${erro.referencia} da ${aba}.`;
  return null;
}
